import {Component} from "@angular/core";
import {SizeGroupEntityModel} from "../size-group-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {SizeGroupValuesSearchModel} from "../size-group-values-search.model";

@Component({
    selector: "wbo-size-group-values-search-page",
    templateUrl: "./size-group-values-search-page.component.html",
    providers: [provideSearchModel(SizeGroupValuesSearchModel), provideEntityModel(SizeGroupEntityModel)]
})
export class SizeGroupValuesSearchPageComponent extends AbstractSearchPage {
}
